import LoadingIcon from "../../../common/LoadingIcon";
import { NoHistory } from "../ContainerHistory/ContainerHistoryStyles";
import HorizontalScroll from "../../../common/HorizontalScroll";
import {
  NoWrapFlashPCBTable,
  TableCell,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
} from "../../../../constants/Styles";
import React, { useRef } from "react";
import { dateStringToHumanReadableDate } from "../../../../utils/valueFormatting";
import { TableContainer } from "./ShipmentsUsingPartStyles";
import BoardLink from "../../../common/BoardLink";
import { ShipmentPartAllocationDetail } from "../../../../utils/hooks/inventory/shipmentsThatNeedPart";
import useUpcomingShipmentsUsingPart from "../../../../utils/hooks/inventory/upcomingShipmentsUsingPart";

function ShipmentRow({
  shipmentPartAllocationDetail,
}: {
  shipmentPartAllocationDetail: ShipmentPartAllocationDetail;
}) {
  return (
    <TableRow>
      <TableCell>
        <BoardLink
          projectName={shipmentPartAllocationDetail.board.project_name}
          boardId={shipmentPartAllocationDetail.board.id}
        />
      </TableCell>
      <TableCell>
        {shipmentPartAllocationDetail.ship_date &&
          dateStringToHumanReadableDate(shipmentPartAllocationDetail.ship_date)}
      </TableCell>
      <TableCell>
        {shipmentPartAllocationDetail.board.order_summary &&
          shipmentPartAllocationDetail.board.order_summary.state}
      </TableCell>
      <TableCell>
        {shipmentPartAllocationDetail.required_amount.toLocaleString()}
      </TableCell>
      <TableCell>
        {shipmentPartAllocationDetail.total_allocated_amount.toLocaleString()}
      </TableCell>
    </TableRow>
  );
}

export default function ShipmentsUsingPart({ partId }: { partId: string }) {
  const tableRef = useRef<HTMLTableElement>(null);

  const { shipmentsPartResponse } = useUpcomingShipmentsUsingPart(partId);

  if (shipmentsPartResponse === null) {
    return (
      <LoadingIcon
        text={"Loading boards..."}
        centerHorizontally
        centerVertically
      />
    );
  }

  if (shipmentsPartResponse.shipments.length === 0) {
    return <NoHistory>No shipments using this part</NoHistory>;
  }

  return (
    <TableContainer>
      <HorizontalScroll childrenRef={tableRef}>
        <NoWrapFlashPCBTable ref={tableRef}>
          <thead>
            <TableHeaderRow>
              <TableHeaderCell>Board</TableHeaderCell>
              <TableHeaderCell>Ship date</TableHeaderCell>
              <TableHeaderCell>Order status</TableHeaderCell>
              <TableHeaderCell>Required amount</TableHeaderCell>
              <TableHeaderCell>Amount allocated</TableHeaderCell>
            </TableHeaderRow>
          </thead>
          <tbody>
            {shipmentsPartResponse.shipments.map(
              (shipmentPartAllocationDetail) => {
                return (
                  <ShipmentRow
                    key={`${shipmentPartAllocationDetail.board.id}-${shipmentPartAllocationDetail.shipment_id}`}
                    shipmentPartAllocationDetail={shipmentPartAllocationDetail}
                  />
                );
              },
            )}
          </tbody>
        </NoWrapFlashPCBTable>
      </HorizontalScroll>
    </TableContainer>
  );
}
